import { TopicPairContentType } from 'src/app/nlp/~store/models/enums/TopicPairContentType';
import { ChannelType } from '../../../contact/~store/models/ChannelType';
import { IOperatorItem } from './OperatorItem';
import { ChatType } from './enums/ChatType';

export interface ILocation {
    longitude: number,
    latitude: number
}

export interface IMessageItem {
    messageId: number,
    chatId: number,
    text: string,
    receivedTimestamp: Date, 
    readTimestamp: Date, 
    messageType: MessageType,
    timeSent: string,
    imageId: string,
    operatorName: string,
    operatorId?: number,
    operatorModel: IOperatorItem,
    location?: ILocation,
    isEdited: boolean,
    fileId: string,
    fileInfo: IFileInfo,
    buttons: IButton[],
    contentType: TopicPairContentType,
    forOperatorsOnly: boolean,
    channelType: ChannelType,
    isFailed: boolean,
    senderName?: string,
    chatType?: ChatType,
    chatSummaryId?: number,
    isDeleted: boolean,
}

export interface IFileInfo {
    fileName: string,
    fileSize: number,
    mimeType: string
}

export enum MessageType {
    operatorMessage = 1,
    clientMessage = 2,
    systemMessage = 3,
    clientSystemMessage = 4,
    previewMessage = 5,
    chatInfoMessage = -1
}

export interface IButton {
    text: string
}  

export interface ISendingMessage {
    message: IMessageItem,
    failed: boolean
}
  